import { useContext } from 'react'
import { ExtraContentsContext } from '@contexts/ExtraContentsContext'

export const useExtraContents = () => {
  return useContext(ExtraContentsContext)
}
